export default function uuidToUrl(uuid: string) {
  return `https://ucarecdn.com/${uuid}/`
}
